import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-variable-array-component', (editor, opts = {}) => {
  const config = {
    blocks: [
      'variableArrayComponent',
    ],
    name: 'variableArrayComponent',
    stylePrefix: 'gjs-',
    labelVariableComp: 'Cantidad de Items en Estados de Arreglo',
    defText: 'Sample',
    category: 'Dinamismo',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
